<template>
	<side-window class="tracking-history" title="Historik" @pop="$emit('pop')" @close="$emit('close')">
		<div class="vehicle-item">
			<div class="label">{{ label }}</div>
		</div>
		<date-picker-view @change="update" class="date-picker" :style="{
			width: '100%'
		}" />
		<div class="vehicle-item">
			<div class="label" style="text-align: center;" @click="print()">UDSKRIV ALLE</div>
		</div>
		<div class="vehicle-item">
			<div class="label" style="text-align: center;" @click="printThis()">UDSKRIV DENNE</div>
		</div>
		<div class="history">
			<div v-for="(event, idx) in history" :key="idx">
				<div class="grid">
					<div>{{ ev[event.event] }}</div>
					<div style="text-align: right;">{{ event.time }}</div>
				</div>
				<div v-if="event.address" class="middle" v-html="event.address"></div>
				<div v-if="event.distance" class="middle">{{ event.distance }}</div>
			</div>
		</div>
	</side-window>
</template>

<script>

	//import Edit from '../../components/Edit'
	//import FormLine from '../../components/FormLine'
	//import FormGrid from '../../components/FormGrid'
	//import Button from '../../components/Button'
	//import Select from '../../components/Select'
	//import Switch from '../../components/Switch'
	//import ProfilePhoto from '../../components/ProfilePhoto'
	//import Tabs from '../../components/Tabs'
	//import Memo from '../../components/Memo'
	//import Entity from '../../components/Entity'

	export default {
		data: function () {
			return {
				vehicles: [],
				history: [],
				date: null,
				ev: {
					start: 'Kørt',
					stop: 'Stoppet',
					enter: 'Ankommet',
					leave: 'Forladt'
				}
			};
		},
		props: {
			id: Number,
			label: String,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			vehicleSelect(id, label) {
				
			},
			update(date) {
				
				this.date = date;

				var win = this;

				this.axios
					.get('/fleet/vehicles/' + this.id + '/events/?date=' + date)
					.then(function (r) {
						win.history = r.data;
					});
			},
			print() {
				
				window.open(process.env.VUE_APP_API + 'geofence/?&date=' + this.date + '&did=' + this.$store.state.department.id);
			},
			printThis() {
				
				window.open(process.env.VUE_APP_API + 'geofence/?&date=' + this.date + '&id=' + this.id);
			}
		},
		mounted: function() {
			
			

			var win = this;

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					win.vehicles = r.data;
				});
		}
	}
</script>

<style lang="scss">
	.vehicle-item {
		padding: 20px 20px 20px 20px;
		border-bottom: 1px solid #333;
		cursor: pointer;
	}

	.date-picker {
		border-bottom: 1px solid #333;
	}

	.history {
		
	}

	.history > div {
		padding: 20px;
		border-bottom: 1px solid #333;
		overflow: hidden;
	}

	.history > div > div.grid {
		display: grid;
		grid-template-columns: 1fr 2fr;
	}

	.history > div > div.middle {
		padding: 10px 0 0 0;
		font-size: 12px;
		overflow: hidden;
	}



	.history > div > div.bottom > div {
		text-align: center;
		overflow: hidden;
	}

	.history > div > div.middle > a {
		color: #f7223f;
	}

	.history > div > div.bottom > div > span {
		display: block;
		text-align: center;
		font-size: 12px;
		color: #ccc;
		padding-bottom: 10px;
	}
</style>
